'use strict';

const _ = require('lodash');
// Vue is a frontend package so must be included like this for compatibility with the frontend webpack in elsa
// otherwise simply doing `require('vue');` won't work in elsa
const Vue = require('vue/dist/vue');

const consts = require('../consts');

const FIXED_EXPENSE_ENVELOPE_TYPES = [
  consts.FIXED_ENVELOPE_TYPE,
  consts.ROLLING_CREDIT_ENVELOPE_TYPE,
];

function getCategories(envelopes) {
  return _.chain(envelopes)
    .groupBy(e => e.details.expense || consts.DEFAULT_FIXED_EXPENSE_CATEGORY)
    .mapValues((categoryEnvelopes, expense) => {
      return {
        expense,
        predictedAmount: _.sumBy(categoryEnvelopes, e => e.predictedAmount),
        balancedAmount: _.sumBy(categoryEnvelopes, e => e.balancedAmount),
        actualsAmount: _.sumBy(categoryEnvelopes, e => e.actualsAmount),
        envelopes: _.map(categoryEnvelopes, e => e.toJson()),
      };
    })
    .value();
}

function _getNormalizedExpenseCategory(envelope) {
  return envelope.details.expense || consts.DEFAULT_FIXED_EXPENSE_CATEGORY;
}

function _normalizeExpenseCategories(envelopes) {
  _.forEach(envelopes, envelope => {
    if (envelope.details) {
      envelope.details.expense = _getNormalizedExpenseCategory(envelope); // eslint-disable-line no-param-reassign
    }
  });
  return envelopes;
}

function create(envelopes) {
  return new Vue({
    data: {
      envelopes: _normalizeExpenseCategories(envelopes),
    },
    computed: {
      fixedExpenseEnvelopes() {
        return _.filter(this.envelopes, e => _.includes(FIXED_EXPENSE_ENVELOPE_TYPES, e.type) && e.isExpense);
      },
      fixedIncomeEnvelopes() {
        return _.filter(this.envelopes, e => e.type === consts.FIXED_ENVELOPE_TYPE && !e.isExpense);
      },
      rollingCreditEnvelope() {
        return _.filter(this.envelopes, e => e.type === consts.ROLLING_CREDIT_ENVELOPE_TYPE);
      },
      fixedExpenseEnvelopesPredictedSum() {
        return _.sumBy(this.fixedExpenseEnvelopes, e => e.predictedAmount);
      },
      fixedExpenseEnvelopesBalanceSum() {
        return _.sumBy(this.fixedExpenseEnvelopes, e => e.balancedAmount);
      },
      fixedExpenseEnvelopesActualSum() {
        return _.sumBy(this.fixedExpenseEnvelopes, e => e.actualsAmount);
      },
      fixedIncomeEnvelopesPredictedSum() {
        return _.sumBy(this.fixedIncomeEnvelopes, e => e.predictedAmount);
      },
      fixedIncomeEnvelopesBalanceSum() {
        return _.sumBy(this.fixedIncomeEnvelopes, e => e.balancedAmount);
      },
      fixedIncomeEnvelopesActualSum() {
        return _.sumBy(this.fixedIncomeEnvelopes, e => e.actualsAmount);
      },
      expenseCategories() {
        return getCategories(this.fixedExpenseEnvelopes);
      },
      incomeCategories() {
        return getCategories(this.fixedIncomeEnvelopes);
      },
    },
  });
}

module.exports = {
  create,
};
